export function useStaticAsset() {
  const { t, te } = useI18n();
  const runtimeConfig = useRuntimeConfig();

  function doesExistsAsset(translationKey: string, prefixJsonFile: string = 'assets'): boolean {
    return te(`${prefixJsonFile}.${translationKey}`);
  }

  function get(translationKey: string, prefixJsonFile: string = 'assets'): string {
    const filePath = t(`${prefixJsonFile}.${translationKey}`);
    return `${runtimeConfig.public.s3BaseUrl}${filePath}`;
  }

  function from(translationKey: MaybeRefOrGetter<string>, prefixJsonFile: string = 'assets') {
    return computed(() => get(toValue(translationKey), prefixJsonFile));
  }

  return {
    get,
    from,
    doesExistsAsset,
  };
}